/**
 * Mission Dresseur — Brand registry (frontend SSOT).
 *
 * Import-only API. Components MUST consume here, never inline.
 *
 *   import { BrandLogo, BrandMark, tokens, icons } from "@/brand";
 */
import tokens from "./tokens.json";

export { BrandLogo, BrandMark } from "./logo/BrandLogo";
export * as icons from "./icons";
export { tokens };

// Convenience aliases — read-only references to the registry
export const brand = tokens.brand;
export const palette = tokens.core;
export const rarityColors = tokens.rarity;
export const space = tokens.space;
export const radius = tokens.radius;
export const motion = tokens.motion;
